// extracted by css-extract-rspack-plugin
export default {"treeNodeMenu":"VhyAKK9N1GYa9vnz"};